import React, {useRef, useState} from 'react';
import { Grid } from '@material-ui/core';
import { useHistory } from 'react-router-dom'
import { withTranslation } from 'react-i18next'
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    root: {
      display: 'flex',
      backgroundColor: "none",
      alignItems: "center"
    },
    media: {
        height: "6em",
    },  
    divImgProduct: {
      position: 'relative',
      paddingLeft: '3rem'
    },
    divProduct: {
      cursor: 'pointer',
      padding: '1rem 2rem',
      display: 'flex',
      alignItems: 'center',
      '&:hover': {
        background: "#f3f3f3",
        borderRadius: '5px'
      },
    }
  }));

const Product = ({ t }) => {
    const classes = useStyles();
    const [isHovering1, setIsHovering1] = useState(false)
    const [isHovering2, setIsHovering2] = useState(false)
    const [isHovering3, setIsHovering3] = useState(false)
    const [isHovering4, setIsHovering4] = useState(false)
    const [isHovering5, setIsHovering5] = useState(false)

  return (
    <div className="relative">
      <Grid container direction="row">
        <Grid container xs={12} md={6} id="productSectionLeft">
          <Grid className={classes.divProduct} onMouseEnter={()=> setIsHovering1(true)} onMouseLeave={()=> setIsHovering1(false)}>
            <div>
              <span className="icon-qk-phone-wa font-size-36 mr-20"></span>
            </div>
            <div>
              <h1 className='font-size-20 reguler'>{t('products.userOnboard')}</h1>
              <p className='font-size-16 thin m-0'>{t('products.userOnboardDesc')}</p>
            </div>
          </Grid>
          <Grid className={classes.divProduct} onMouseEnter={()=> setIsHovering2(true)} onMouseLeave={()=> setIsHovering2(false)}>
            <div>
              <span className="icon-qk-lock-phone font-size-36 mr-20"></span>
            </div>
            <div>
              <h1 className='font-size-20 reguler'>{t('products.passLess')}</h1>
              <p className='font-size-16 thin m-0'>{t('products.passLessDesc')}</p>
            </div>
          </Grid>
          <Grid className={classes.divProduct} onMouseEnter={()=> setIsHovering3(true)} onMouseLeave={()=> setIsHovering3(false)}>
            <div>
              <span className="icon-qk-search font-size-36 mr-20"></span>
            </div>
            <div>
              <h1 className='font-size-20 reguler'>{t('products.infoVerif')}</h1>
              <p className='font-size-16 thin m-0'>{t('products.infoVerifDesc')}</p>
            </div>
          </Grid>
          <Grid className={classes.divProduct} onMouseEnter={()=> setIsHovering4(true)} onMouseLeave={()=> setIsHovering4(false)}>
            <div>
              <span className="icon-qk-lock-ref font-size-36 mr-20"></span>
            </div>
            <div>
              <h1 className='font-size-20 reguler'>{t('products.seamless')}</h1>
              <p className='font-size-16 thin m-0'>{t('products.seamlessDesc')}</p>
            </div>
          </Grid>
          <Grid className={classes.divProduct} onMouseEnter={()=> setIsHovering5(true)} onMouseLeave={()=> setIsHovering5(false)}>
            <div>
              <span className="icon-qk-chart font-size-36 mr-20"></span>
            </div>
            <div>
              <h1 className='font-size-20 reguler'>{t('products.analyticsReport')}</h1>
              <p className='font-size-16 thin m-0'>{t('products.analyticsReportDesc')}</p>
            </div>
          </Grid>
        </Grid>
        <Grid id="imgDummyProduct" className="absolute opacity-1">
          <img src="/product-01.png" width="100%"/>
        </Grid>
        <Grid className={classes.divImgProduct} container xs={12} md={6} alignItems='center'>
          <Grid className={`absolute ${isHovering1 ? "" : "opacity-0"}`}>
            <img className='imgProduct' src="/product-01.png" width="100%"/>
          </Grid>
          <Grid className={`absolute ${isHovering3 ? "" : "opacity-0"}`}>
            <img className='imgProduct' src="/product-02.png" width="100%"/>
          </Grid>
          <Grid className={`absolute ${isHovering2 ? "" : "opacity-0"}`}>
            <img className='imgProduct' src="/product-03.png" width="100%"/>
          </Grid>
          <Grid className={`absolute ${isHovering5 ? "" : "opacity-0"}`}>
            <img className='imgProduct' src="/product-04.png" width="100%"/>
          </Grid>
          <Grid className={`absolute ${isHovering4 ? "" : "opacity-0"}`}>
            <img className='imgProduct' src="/product-05.png" width="100%"/>
          </Grid>
        </Grid>
      </Grid>
  </div>
  );
}
export default withTranslation()(Product);